import { render, staticRenderFns } from "./shopCar.vue?vue&type=template&id=c10ddf68&scoped=true"
import script from "./shopCar.vue?vue&type=script&lang=js"
export * from "./shopCar.vue?vue&type=script&lang=js"
import style0 from "./shopCar.vue?vue&type=style&index=0&id=c10ddf68&prod&lang=scss"
import style1 from "./shopCar.vue?vue&type=style&index=1&id=c10ddf68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10ddf68",
  null
  
)

export default component.exports